export const getShareLink = () => {
  const location = window.location;
  if(!location) return '';
  return `${location.origin}${location.pathname}?&_share=1`;
};

export const inflect = function(number, wordForms) {
  const cases = [2, 0, 1, 1, 1, 2]

  return wordForms[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]
}